<template>
  <div class="user">

    <div class="qrcode-wrap" v-if="isShowQrcode">
      <img src="@/assets/images/qrcode.png" alt="" @click="clickQrCode" />
      <span @click="clickQrCode" >点击放大</span>
      <div>南京东路街道助老卡</div>
    </div>
    <div class="avatar" v-else>
      <img src="@/assets/images/tx5.png" alt="" />
    </div>


    <div class="family">
      <div class="item">
        <van-cell title="我的家人" is-link @click="myFamily">
          <template #icon>
            <img src="@/assets/images/friends.png" alt="" />
          </template>
        </van-cell>
        <div class="card">
          <van-swipe class="my-swipe" :autoplay="3000" :show-indicators="false" :width="234" :loop="false" v-if="true">
            <van-swipe-item v-for="item in cardList" :key="item.id">
              <div class="card_item" :class="{ man: item.sex === '0' }">
                <div class="left">
                  <img v-if="item.sex === '1'" src="@/assets/images/youngwoman.png" alt="" />
                  <img v-else src="@/assets/images/youngman.png" alt="" />
                </div>
                <div class="middle">
                  <p>{{ item.myRelationName }}</p>
                  <p>{{ item.fullName }}</p>
                </div>
                <div class="right">{{ item.idCard | GetAge }}</div>
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
    </div>

    <div class="item">
      <van-cell title="已享受服务" is-link to="enjoyedService">
        <template #icon>
          <img src="@/assets/images/alreadyServic.png" alt="" />
        </template>
      </van-cell>
    </div>
    <div class="item">
      <van-cell title="申请记录" is-link to="applicationRecord">
        <template #icon>
          <img src="@/assets/images/record.png" alt="" />
        </template>
      </van-cell>
    </div>
    <div class="item">
      <van-cell title="个人信息" is-link @click="personInfo">
        <template #icon>
          <img src="@/assets/images/personInfo.png" alt="" />
        </template>
      </van-cell>
    </div>
    <div class="out-login" @click="outLogin">
      退出登录
    </div>

    <div class="mask" @click="isShowMask = false" v-show="isShowMask">
      <div class="wrap">
        <div class="name">{{ showName }}</div>
        <div id="qrcode" ref="qrcode"></div>
        <div class="text">南京东路街道助老卡</div>
        <!-- <div >
        
        </div> -->
          <img src="@/assets/images/close.png" class="close" alt=""  />
      </div>

    </div>

  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { getFamilyInfoList, getUserInfoDetail } from "@/api/user.js";
import { areaCode } from "@/common/constants.js";
import QRCode from 'qrcodejs2';
import { getAgeByIDCard } from "@/utils/index.js";
export default {
  name: "User",
  data() {
    return {
      form: {
        areaCode
      },
      cardList: [],
      info: {},
      isShowQrcode: false,
      isShowMask: false,
      showName: '',

    };
  },
  methods: {
    ...mapMutations("user", ["setOpenId"]),
    myFamily() {
      this.$router.push("myFamily");
    },
    // 获取家人信息
    async FamilyInfo() {
      const { data } = await getFamilyInfoList({
        ...this.form,
        openId: this.openId
      });
      this.cardList = data;
    },
    async getData() {
      const { data } = await getUserInfoDetail(this.openId);
      this.info = data;
      if (this.info.idCard) {
        if(getAgeByIDCard(this.info.idCard) >= 65){
          this.isShowQrcode = true;
          this.showName = this.info.fullName;
          this.creatQrCode(this.info.idCard)
        }
      }
    },
    personInfo() {
      console.log("3", this.info);
      this.$router.push({
        name: "personInfo"
      });
    },
    // 退出登录
    outLogin() {
      // 删除openid
      window.localStorage.removeItem("openId");
      // 设置store中openId为空
      this.setOpenId("");
      this.$router.push({
        name: "login"
      });
    },

    creatQrCode(text) {
      let qrcode = new QRCode(this.$refs.qrcode, {
        text: text, //二维码内容字符串
        width: 256, //图像宽度
        height: 256, //图像高度
        colorDark: 'rgb(255,197,0)', //二维码前景色
        colorLight: '#ffffff', //二维码背景色
        correctLevel: QRCode.CorrectLevel.H, //容错级别
      })
    },

    clickQrCode() {
      this.isShowMask = true
    }
  },
  computed: {
    ...mapState("user", ["userInfo", "openId"])
  },
  mounted() {
    // 判断是否登录，如未登录跳转到登录页
    if (this.openId) {
      this.FamilyInfo();
      this.getData();
    } else {
      this.$router.push({
        name: 'login'
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.user {
  background-color: #fff8e9;
  padding-bottom: 10px;


  .mask {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, .5);

    display: flex;
    justify-content: center;
    align-items: center;
    .wrap{
      width: 90%;
      aspect-ratio: 5/6;
      background: #fff;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: center;
      position: relative;
      .name{
        font-size: 26px;
      }
      .text{
        font-size: 16px;
      }

      .close{
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 105%;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        // border: 2px solid #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        font-size: 22px;
    }

    }


  }


  .avatar {
    position: relative;
    // border-bottom: 8px solid #fff8e9;
    background-color: #fff;
    // padding-bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      margin: 20px 0;
      width: 104px;
      height: 102px;

      &:nth-child(2) {
        position: absolute;
        top: 15px;
        width: 76px;
        height: 76px;
        border-radius: 50%;
      }
    }


  }

  .qrcode-wrap {
    position: relative;
    background-color: #fff;
    padding: 20px 0;
    overflow: hidden;

    img {
      display: block;
      margin: 0px auto;
      width: 104px;
      height: 102px;
    }

    span {
      color: #fff;
      position: absolute;
      font-size: 14px;
      text-align: center;
      top: 90px;
      left: 0px;
      width: 100%;
    }

    div {
      margin-top: 10px;
      font-size: 22px;
      text-align: center;
    }
  }



  .family {
    .card {
      .my-swipe .van-swipe-item {
        // background-color: red;
        padding-bottom: 10px;
        color: #fff;
        font-size: 20px;
        line-height: 150px;
        text-align: center;

        .card_item {
          box-shadow: 2px 2px 10px #ccc;
          border-radius: 10px;
          color: #654614;
          display: flex;
          justify-content: space-between;
          width: 218px;
          height: 96px;
          background-color: #ffedbb;

          .left {
            margin-left: 10px;
            width: 70px;
            height: 70px;

            // background-color: red;
            img {
              width: 56px;
            }
          }

          .middle {
            width: 100px;

            p {
              line-height: 50px;
              opacity: 0.9;
              font-size: 16px;
              font-family: PingFang SC, PingFang SC-Bold;
              font-weight: 700;
              text-align: center;
              color: #543302;
            }
          }

          .right {
            margin-right: 10px;
            opacity: 0.9;
            font-size: 16px;
            font-family: PingFang SC, PingFang SC-Bold;
            font-weight: 700;
            text-align: center;
            color: #543302;
            line-height: 50px;
          }
        }

        .man {
          background-color: #d2eeff;
        }
      }
    }
  }

  .out-login {
    box-sizing: border-box;
    width: 100%;
    height: 45px;
    line-height: 45px;
    text-align: center;
    // padding-top: 10px;
    font-size: 16px;
    color: #ff703c;
    background-color: #fff;
    margin-top: 10px;
    // border-bottom: 4px solid #fff8e9;
  }

  .item {
    // border-bottom: 4px solid #fff8e9;
    padding-top: 10px;

    .van-cell {
      &::after {
        border-bottom: none;
      }

      padding-left: 10px;
      padding-right: 10px;

      img {
        width: 18px;
        height: 18px;
        opacity: 1;
        margin-top: 2px;
      }

      span {
        margin-left: 12px;
        width: 80px;
        height: 22px;
        opacity: 1;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Bold;
        font-weight: 700;
        text-align: left;
        color: #222222;
      }

      .van-icon::before {
        opacity: 1;
        color: #000;
        font-size: 20px;
      }
    }
  }
}
</style>
